import { render, staticRenderFns } from "./xePivotTableSetting.vue?vue&type=template&id=766b4d33"
import script from "./xePivotTableSetting.vue?vue&type=script&lang=js"
export * from "./xePivotTableSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports